/**
 * Canonical auth URLs at the site root (marketing + shared entry).
 * Registration uses the same screen as sign-in with ?signup=1. `/sign-up` is a redirect for old links.
 */
export const PUBLIC_SIGN_IN_PATH = '/sign-in' as const
export const PUBLIC_SIGN_UP_PATH = '/sign-up' as const
export const PUBLIC_SIGN_OUT_PATH = '/sign-out' as const
/** Guest-first front door — where sign-out lands (Get Started / I already have an account). */
export const PUBLIC_WELCOME_PATH = '/welcome' as const

/** When set to `1` (or `true`), `/sign-in` opens in create-account mode. */
export const PUBLIC_AUTH_SIGNUP_QUERY_KEY = 'signup' as const
export const PUBLIC_AUTH_SIGNUP_QUERY_VALUE = '1' as const

export function isPublicAuthSignupQueryValue(value: unknown): boolean {
  if (value === undefined || value === null) return false
  const v = Array.isArray(value) ? value[0] : value
  return v === PUBLIC_AUTH_SIGNUP_QUERY_VALUE || v === 'true'
}
